import { useMutation } from '@tanstack/react-query';

import {
    callDeleteCompetitionWishlists,
    type DeleteCompetitionWishlists,
} from '@app/client/resources/admin/fantasy/competitions';
import { COMPETITIONS_LEADERBOARD_CACHE } from '@app/client/resources/competitions';
import { WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';

import { useQueryInvalidation } from '../../../reactQuery';
import { useAppSelector } from '../../../redux';

export function useDeleteCompetitionWishlists() {
    const caches = [...WISHLIST_SUMMARY_CACHE, ...COMPETITIONS_LEADERBOARD_CACHE];
    const invalidateQueries = useQueryInvalidation(caches);
    // TODO - this should be a specific user (not current user) when we have a player list
    const currentUserId = useAppSelector((s) => s.user.userAccount?.user.id);
    const onError = (e) => alert(e);
    const destroyWishlists = true;
    return useMutation({
        mutationFn: ({ id, user_id }: Omit<DeleteCompetitionWishlists, 'value'>) =>
            callDeleteCompetitionWishlists({
                id,
                value: {
                    user_id: user_id || currentUserId,
                    destroy_associated_wishlist: destroyWishlists,
                },
            }),
        onSuccess: () => {
            invalidateQueries();
            alert(`Successfully destroyed competition lineups for user.`);
        },
        onError,
    });
}
